export const categories = [
  { key: "all", label: "全部主角" },
  { key: "caiyi", label: "才艺" },
  { key: "shouyi", label: "手作非遗" },
  { key: "zhiye", label: "职业达人" },
  { key: "mengchong", label: "萌宠治愈" },
  { key: "biaoda", label: "表达" },
];

export interface Person {
  id: string;
  name: string;
  nick: string;
  category: string;
  categoryLabel: string;
  city: string;
  heat: string;
  trend: string;
  tags: string[];
  intro: string;
  story: string;
  img: string;
}

export const people: Person[] = [
  {
    id: "renwu-01",
    name: "阿澈",
    nick: "吉他手阿澈",
    category: "caiyi",
    categoryLabel: "才艺",
    city: "成都",
    heat: "1280万",
    trend: "+38%",
    tags: ["街头翻唱", "吉他", "治愈男声"],
    intro: "在成都街头把一首老歌唱出圈的音乐少年，靠真实不修音的现场圈粉无数。",
    story: "没有剪辑包装，也没有华丽声卡。阿澈只用一把旧吉他和一台补光灯，就把地铁口变成了属于自己的舞台。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20a%20cheerful%20young%20Chinese%20male%20singer%20holding%20an%20acoustic%20guitar%20mid-strum%20in%20a%20linen%20shirt%2C%20sunlit%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-ac-01&orientation=portrait",
  },
  {
    id: "renwu-02",
    name: "陶小满",
    nick: "返乡陶娘",
    category: "shouyi",
    categoryLabel: "手作非遗",
    city: "景德镇",
    heat: "960万",
    trend: "+22%",
    tags: ["陶艺", "返乡", "手作日常"],
    intro: "从大厂辞职回到景德镇做土陶的姑娘，一条手作视频让老手艺重获年轻人关注。",
    story: "她把揉泥、拉坯、上釉的全过程拍成安静的日常，意外的质朴感反而成了最稀缺的内容。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20a%20gentle%20young%20Chinese%20woman%20potter%20with%20clay-stained%20hands%20holding%20a%20handmade%20terracotta%20vase%20in%20a%20sunlit%20studio%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-tao-02&orientation=portrait",
  },
  {
    id: "renwu-03",
    name: "大橙Tony",
    nick: "县城Tony",
    category: "zhiye",
    categoryLabel: "职业达人",
    city: "义乌",
    heat: "880万",
    trend: "+19%",
    tags: ["美发", "技能", "反差"],
    intro: "县城理发师凭一手剪发绝活火遍全网，被网友笑称“隐藏的托尼老师天花板”。",
    story: "没有光鲜的店面和昂贵的道具，他靠几十年练就的手上功夫，把普通剪刀玩成了手艺表演。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20a%20confident%20young%20Chinese%20male%20barber%20styling%20hair%20with%20scissors%20in%20a%20cozy%20vintage%20barbershop%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-tony-03&orientation=portrait",
  },
  {
    id: "renwu-04",
    name: "奶糖酱",
    nick: "猫咖奶糖",
    category: "mengchong",
    categoryLabel: "萌宠治愈",
    city: "厦门",
    heat: "1120万",
    trend: "+31%",
    tags: ["猫咖", "治愈", "日常"],
    intro: "猫咖店员与毛孩子之间的暖心互动，让忙碌的年轻人找到一处情绪出口。",
    story: "她从不刻意煽情，只是记录真实的工作日常。那些小猫打盹、撒娇的小瞬间，治愈了屏幕前无数人。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20a%20young%20Chinese%20woman%20holding%20a%20fluffy%20orange%20cat%20in%20a%20cozy%20cat%20cafe%20with%20soft%20window%20light%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-nai-04&orientation=portrait",
  },
  {
    id: "renwu-05",
    name: "皮影阿辛",
    nick: "皮影少年",
    category: "shouyi",
    categoryLabel: "手作非遗",
    city: "西安",
    heat: "760万",
    trend: "+16%",
    tags: ["皮影戏", "直播", "传统文化"],
    intro: "把古老皮影戏搬进直播间的一代，让传统手艺在年轻化表达中重新发光。",
    story: "他用年轻人听得懂的话讲皮影背后的故事，把渐被遗忘的老手艺做成了每晚准时的“电子戏台”。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20a%20young%20Chinese%20man%20operating%20a%20traditional%20shadow%20puppet%20behind%20a%20backlit%20screen%2C%20warm%20glow%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-ashin-05&orientation=portrait",
  },
  {
    id: "renwu-06",
    name: "话痨小北",
    nick: "开口即炸",
    category: "biaoda",
    categoryLabel: "表达",
    city: "南京",
    heat: "1040万",
    trend: "+27%",
    tags: ["脱口秀", "素人", "炸场"],
    intro: "第一次上台就炸场的话痨素人，用生活化段子讲出当代年轻人的心里话。",
    story: "没有段子手团队，他把早高峰、租房、点外卖的日常讲成让人又笑又共鸣的脱口秀，意外圈粉。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20gouache%20illustration%20portrait%20of%20an%20energetic%20young%20Chinese%20man%20speaking%20into%20a%20microphone%20on%20an%20open%20mic%20stage%20with%20warm%20spotlight%2C%20cream%20paper%20background%2C%20textured%20gouache%20and%20grain%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space&width=600&height=800&seq=people-xiaobei-06&orientation=portrait",
  },
];